import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { DAYS_OF_WEEK } from '../../../form/fields/AllDaysPreferencesField/AllDaysPreferencesField.constants';
import { translationKeys } from '../../../translations';
import { TIMES_OF_DAY } from '../../../form/fields/DayPreferenceField/DayPreferenceField.constants';

import {
   StyledPatientAvailabilityPreferenceCell,
   StyledPatientAvailabilityPreferenceWholeDay,
} from './PatientAvailabilityPreferenceCell.styled';
import { PatientAvailabilityPreferenceCellAvailabilities } from './PatientAvailabilityPreferenceCellAvailabilities';
import { PatientAvailabilityPreferenceCellTooltip } from './PatientAvailabilityPreferenceCellTooltip';
import { MAX_DISPLAYABLE_DAYS_COUNT, usePatientAvailabilities } from './PatientAvailabilityPreferenceCell.hooks';

type PatientAvailabilityPreferenceCellProps = Pick<WaitlistEntry, 'patientAvailability'> & {
   important: boolean;
};

export const PatientAvailabilityPreferenceCell = (props: PatientAvailabilityPreferenceCellProps): ReactElement => {
   const { displayableAvailabilities, allAvailabilities } = usePatientAvailabilities(props.patientAvailability);

   const allTimesSelected = allAvailabilities.every(
      (availability) => availability.timesOfDay.length === TIMES_OF_DAY.length
   );

   if (allAvailabilities.length === DAYS_OF_WEEK.length && allTimesSelected) {
      return (
         <StyledPatientAvailabilityPreferenceCell $important={props.important}>
            <StyledPatientAvailabilityPreferenceWholeDay>
               <Translate>{translationKeys.wholeWeek}</Translate>
            </StyledPatientAvailabilityPreferenceWholeDay>
         </StyledPatientAvailabilityPreferenceCell>
      );
   }

   return (
      <StyledPatientAvailabilityPreferenceCell $important={props.important}>
         <StyledFlex direction={'column'}>
            <PatientAvailabilityPreferenceCellAvailabilities availabilities={displayableAvailabilities} />
         </StyledFlex>
         {allAvailabilities.length > MAX_DISPLAYABLE_DAYS_COUNT ? (
            <PatientAvailabilityPreferenceCellTooltip availabilities={allAvailabilities} />
         ) : null}
      </StyledPatientAvailabilityPreferenceCell>
   );
};
